import { IUser } from './users.model';
import { Injectable } from '@angular/core';
import { dispatch } from '@angular-redux/store';
import { AnyAction } from 'redux';

@Injectable()
export class UserActionService {

    static USER_LIST = 'USER_LIST';
    static DELETE_USER = 'DELETE_USER';
    static ADD_OR_UPDATE_USER = 'ADD_OR_UPDATE_USER';
    static MODIFY_USER = 'MODIFY_USER';
    static SET_USER_CURRENT = 'SET_USER_CURRENT';

    constructor() {

    }

    @dispatch()
    userList = ( data ): AnyAction => ({ type: UserActionService.USER_LIST, payload: data })

    @dispatch()
    addOrUpdateUser = ( data: IUser ): AnyAction => ({ type: UserActionService.ADD_OR_UPDATE_USER, payload: data })

    @dispatch()
    deleteUser = ( data ): AnyAction => ({ type: UserActionService.DELETE_USER, payload: data })

    @dispatch()
    modifyUser = ( data ): AnyAction => ({ type: UserActionService.MODIFY_USER, payload: data })

    @dispatch()
    setUserCurrent = ( data ): AnyAction => ({ type: UserActionService.SET_USER_CURRENT, payload: data })

}
